<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('endOrder.couponCodeNotAppliedTitle')"
    [acceptText]="t('endOrder.removeCoupon')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('endOrder.couponCodeInvalidOrExpiredError') }}</p>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
